import React, { useMemo, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { toogleForm } from "../../../Utils/appSlice";
import { toogleVerify } from '../../../Utils/verifyblogSlice';
import axios from 'axios';
import JoditEditor from 'jodit-react';

const BlogForm = ({setFormValue}) => {

  const [img, setImg] = useState(null);
  const [aud, setAud] = useState(null);
  const [category, setCategory] = useState("");
  const [heading, setHeading] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const editor = useRef(null);

  const toggleFormHandler = () => {
    dispatch(toogleForm());
    setContent("");
    setHeading("");
    setImg(null);
    setAud(null);
    setLoading(false);
  }

  const editorConfig = useMemo(
    () => ({
      placeholder: "Start Typing....",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "small",
      toolbarAdaptive: false,
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: true,
      askBeforePasteFromWord: true,
      buttons: "undo,redo,|,font,fontsize,bold,strikethrough,underline,italic,superscript,subscript,brush,|,align,ul,ol,outdent,indent,paragraph,|,link,table,|,hr,eraser,copyformat,|,cut,copy,paste,selectall,|,source,print,|,fullsize,|",
      uploader: {
        insertImageAsBase64URI: true,
      },
      allowResizeY: false,
      height: 300,
      maxHeight: 300,
    }),
    []
  );

  const uploadFile = async (type) => {
    const data = new FormData();
    data.append("file", type === "image" ?  img : aud);
    data.append("upload_preset", type === "image" ? 'images_preset' : 'audio_preset');

    try{
      const resourceType = type === 'image'? 'image' : 'video';
      const api = `https://api.cloudinary.com/v1_1/ddbrxrvat/${resourceType}/upload`;
      const res = await axios.post(api, data);
      const { secure_url } = res.data;
      return secure_url;
    } catch (err) {
      console.log(err);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      setLoading(true);
      // Upload image
      const imgUrl = await uploadFile('image');
      // Upload audio
      const audUrl = await uploadFile('audio');
      await setFormValue({
        category: category,
        heading: heading,
        content: content,
        image: imgUrl,
        audio: audUrl
      })
      if(audUrl){
        dispatch(toogleForm());
        dispatch(toogleVerify());
        setContent("");
        setHeading("");
        setAud(null);
        setLoading(false);
      } else if(imgUrl){
        dispatch(toogleForm());
        dispatch(toogleVerify());
        setContent("");
        setHeading("");
        setImg(null);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <div tabIndex="-1" className="max-h-full fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0">
          <div className="relative w-full max-w-lg max-h-full mx-auto">
              <div className="relative bg-white rounded-lg shadow ">
                  <div className='flex items-center justify-between px-6 py-4'>
                      <h1 className='text-[#231F20] text-xl leading-8 font-figtree font-semibold'>Add New Blog</h1>
                      <button type="button" className="text-[#999CA0]" onClick={() => toggleFormHandler()}>
                          <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                          </svg>
                      </button>
                  </div>
                  <div className='w-full h-[1px] bg-[#F2F2F2]'></div>
                  <div className='p-6 flex flex-col gap-6'>     
                    <form onSubmit={handleSubmit} className='flex flex-col gap-5'>
                        <div className='flex flex-col'>
                          <label htmlFor="category" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Select Category<span className='text-[#ff3535] text-lg'>*</span></label>
                          <div className='w-full rounded-lg border border-[#F2F2F2]'>
                            <select
                              required
                              type="text"
                              name="category"
                              onChange={(e) => setCategory(e.target.value)}
                              value={category}
                              placeholder='Eg. ऋग्वेद से अग्नि मंत्र'
                              className='w-full px-4 py-3 bg-transparent text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                            >
                              <option selected value=''>Select Category</option>
                              <option value="Daily Mantras">Daily Mantras</option>
                              <option value="Did you know?">Did you know?</option>
                              <option value="Rituals">Rituals</option>
                              <option value="Spirituality and science">Spirituality and science</option>
                            </select>
                          </div>
                        </div>
                        <div className='flex flex-col'>
                          <label htmlFor="heading" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Enter Blog Heading<span className='text-[#ff3535] text-lg'>*</span></label>
                          <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                            <input
                              required
                              type="text"
                              name="heading"
                              onChange={(e) => setHeading(e.target.value)}
                              value={heading}
                              placeholder='Eg. ऋग्वेद से अग्नि मंत्र'
                              className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                            />
                          </div>
                        </div>
                        <div className='flex flex-col'>
                          <label htmlFor="content" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Enter Blog Content<span className='text-[#ff3535] text-lg'>*</span></label>
                          <div className='w-full rounded-lg border border-[#F2F2F2]'>
                            <JoditEditor
                              ref={editor}
                              defaultValue={content}
                              config={editorConfig}
                              tabIndex={2}
                              onChange={newContent => setContent(newContent)}
                            />
                          </div>
                        </div>
                        <div className='flex flex-col'>
                          <label htmlFor="image" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Select Image<span className='text-[#ff3535] text-lg'>*</span></label>
                          <div className='w-full rounded-lg border border-[#F2F2F2]'>
                            <input
                              required
                              type="file"
                              name="image"
                              accept="image/*"
                              onChange={(e) => setImg((prev) => e.target.files[0])}
                              className='w-full px-4 py-3 text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                            />
                          </div>
                        </div>
                        <div className='flex flex-col'>
                          <label htmlFor="audio" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Select Audio (Optional)</label>
                          <div className='w-full rounded-lg border border-[#F2F2F2]'>
                            <input
                              type="file"
                              name="audio"
                              onChange={(e) => setAud((prev) => e.target.files[0])}
                              accept="audio/mp3"
                              className='w-full px-4 py-3 text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                            />
                          </div>
                        </div>
                        <div className='w-full h-[0.5px] bg-[#F2F2F2]'></div>
                        <div className='text-center'>
                          <button type="submit" disabled={loading} className='w-[24%] bg-[#3E84F8] disabled:opacity-50 rounded-[8px] px-4 py-2 text-[#FFF] text-sm font-figtree font-semibold'>
                            {!loading ? 'Submit' : 'Uploading'}
                          </button>
                        </div>
                    </form>
                  </div>
              </div>
          </div>
      </div>
      <div className='w-full h-full bg-[#282c3f]/[0.5] fixed top-0 left-0 z-[49]' onClick={() => toggleFormHandler()}></div>
    </>
  );
}

export default BlogForm;